// import styled, { css } from 'styled-components';
import styled from 'styled-components';

// const dragActive = css`
//   border-color: ${props => props.theme.button.success.out};
// `;

// const dragReject = css`
//   border-color: ${props => props.theme.button.danger.in};
// `;

export const Container = styled.div`
  padding: 0;
  margin: 0;
  // height: 100%;
  display: flex;
  justify-content: flex-start;
  width: 100%;
`;

export const DropContainer = styled.div`
  /* border: 1px dashed #ddd; */
  /* border-radius: 4px; */

  // border: 3px solid white;
  padding: 0;
  margin: 0;
  cursor: pointer;
  transition: height 0.2s ease;
`;

export const FileInfo = styled.ul`
  border: 3px solid white;
  padding: 0;
  margin: 0;
  li {
    display: flex;
    flex-direction: row;
    align-items: center;

    div {
      strong {
        margin-right: 10px;
      }
    }
  }
`;
